import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import generatedRoutes from '~pages'
import { useAuthStore } from 'src/app/auth/stores/useAuthStore'
import {storeToRefs} from 'pinia';
import { useLayout } from '@/composables/useLayouts/useLayout'
import { ELayout } from '@/composables/useLayouts/types'
import {useSystemAlertStore} from "@/app/system-alert/stores/useSystemAlertStore.ts";
import {loadSettings} from "@/modules/settingJsonLoader.ts";
import {useAppStore} from "@/stores/useAppStore.ts";
import {setupAxios} from "@/modules/axios.ts";

const routes: RouteRecordRaw[] = generatedRoutes
const router = createRouter({
    history: createWebHistory(),
    routes,
})

router.beforeEach( async(to, from, next) => {

  const appStore = useAppStore()
  const { admin_api_url } = storeToRefs(appStore)

    if(!admin_api_url?.value?.length) {
      await loadSettings()
      setupAxios(  useAppStore().admin_api_url ?? '')
    }


    const authStore= useAuthStore()
    const { admin } = storeToRefs(authStore)
    if (!admin.value)  await authStore.checkLoggedIn();

    useLayout().switchLayout(to.meta?.layout as ELayout ?? ELayout.BLANK)

    if (!admin.value && to.name !== 'auth.login' ) next({ name: 'auth.login' })
    else if (admin.value && to.name === 'auth.login' ) next({ name: 'dashboard.index' })
    else if (admin.value && to.name === 'index' ) next({ name: 'dashboard.index' })
    else if (to.meta?.permission && !authStore.hasPermission(to.meta?.permission)) {
        useSystemAlertStore().addSuccess({
            message: 'You do not have permission to access this page',
            type: 'warning',
        });
        next({ name : 'access_denied' })
    }
    else next()
})
router.afterEach(() => {
    const lastRoute = router.currentRoute.value
    if (lastRoute && lastRoute.name !== 'auth.login'){
        // localStorage.setItem('lastRoute', JSON.stringify(lastRoute));
    }
})

export default router
